import lazyLoading from './lazyLoading'

export default {
  name: 'HomeNet EV Charge',
  path: '/homenet/evcharge',
  redirect: '/homenet/evcharge/list',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: lazyLoading('homenet', true),
  children: [
    {
      'name': 'List',
      'path': 'list',
      'meta': {
        'label': 'List'
      },
      'component': lazyLoading('homenet/EVCharge')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/evcharge.js